var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "4" } },
            [
              _c("v-text-field", {
                directives: [{ name: "ascii-only", rawName: "v-ascii-only" }],
                attrs: { label: "Name:" },
                model: {
                  value: _vm.value.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.value,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "value.name",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "4" } },
            [
              _c("r-reward-generator-mode", {
                attrs: { model: _vm.value.mode },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.value, "mode", $event)
                  },
                },
              }),
            ],
            1
          ),
          _vm.value.mode.id === 1 || _vm.value.mode.id === 4
            ? _c(
                "v-col",
                { attrs: { cols: "12", sm: "2", md: "2" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "AmountMin:", "hide-details": "" },
                    model: {
                      value: _vm.value.amountMin,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "amountMin", _vm._n($$v))
                      },
                      expression: "value.amountMin",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.value.mode.id === 1 || _vm.value.mode.id === 4
            ? _c(
                "v-col",
                { attrs: { cols: "12", sm: "2", md: "2" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "AmountMax:", "hide-details": "" },
                    model: {
                      value: _vm.value.amountMax,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "amountMax", _vm._n($$v))
                      },
                      expression: "value.amountMax",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("v-row", { staticClass: "ma-2" }),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c("r-guard-rules", {
            attrs: {
              items: _vm.value.guard.allow,
              anyof: _vm.value.guard.allowAnyOf,
              title: "Allow Guards:",
            },
            on: {
              "update:items": function ($event) {
                return _vm.$set(_vm.value.guard, "allow", $event)
              },
              "update:anyof": function ($event) {
                return _vm.$set(_vm.value.guard, "allowAnyOf", $event)
              },
            },
          }),
        ],
        1
      ),
      _c("v-row", { attrs: { dense: "" } }, [_c("v-divider")], 1),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c("r-guard-rules", {
            attrs: {
              items: _vm.value.guard.block,
              anyof: _vm.value.guard.blockAnyOf,
              title: "Block Guards:",
            },
            on: {
              "update:items": function ($event) {
                return _vm.$set(_vm.value.guard, "block", $event)
              },
              "update:anyof": function ($event) {
                return _vm.$set(_vm.value.guard, "blockAnyOf", $event)
              },
            },
          }),
        ],
        1
      ),
      _c("v-row", { attrs: { dense: "" } }, [_c("v-divider")], 1),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "12", md: "12" } },
            [
              _c("r-reward-generator-config-table", {
                attrs: { items: _vm.value.data, view_flags: _vm.view_flags },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }